import React, { useEffect, useLayoutEffect, useState } from "react";
import axios from "axios";

import Loader from "../../Layout/Loader";

import "./login.css";

export default function Login({ auth, setAuth }) {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const [email, password] = e.target;
    try {
      setLoading(true);
      const response = await axios.post(
        process.env.REACT_APP_BACKEND + "/api/v1/login",
        { email: email.value, password: password.value }
      );
      localStorage.setItem("token", response.data.token);
      setAuth(true);
    } catch (error) {
      setAuth(false);
      setMessage("wrong credentials");
    } finally {
      setLoading(false);
    }
  };

  useLayoutEffect(() => {
    const token = localStorage.getItem("token");
    if (token) setAuth(true);
  }, []);

  useEffect(() => {
    if (message)
      setTimeout(() => {
        setMessage("");
      }, 3000);
  }, [message]);
  return (
    <>
      {loading && <Loader />}
      <div className="login-main">
        <form onSubmit={handleSubmit}>
          <div className="center">
            <div className="box">
              <div className="box-main">
                <h2>Welcome Back</h2>
                <div className="input-box">
                  <input type="email" name="email" required />
                  <span>Email</span>
                  <i></i>
                </div>
                <div className="input-box">
                  <input type="password" name="password" required />
                  <span>Password</span>
                  <i></i>
                </div>
                <div className="links">
                  <a href="#">Forget Password</a>
                  <a href="#">Sign Up</a>
                </div>
                <input id="btn" type="submit" value="Login" />
                {message && <span className="error-message">*{message}</span>}
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
